import React from 'react'
import { Link } from 'gatsby'
import FocusedHeader from './FocusedHeader'
// import WorkshopWaitlistForm from '../forms/WorkshopWaitlistForm'

export default function SoldOut({ workshop, context }) {
  return (
    <div className="spacing">
      <FocusedHeader>Sorry, we're sold out for this event.</FocusedHeader>
      <p>
        Please see <Link to="/public-workshops">Our Schedule</Link> for other events.
      </p>
      {/* <p>Add yourself to our waitlist in case more space opens up:</p> */}
      {/* <WorkshopWaitlistForm
        ckTag={context.workshopData && context.workshopData.ckTag}
        workshopId={workshop.id}
        startDate={workshop.startDate}
      /> */}
    </div>
  )
}
